export const SETDETAILSPPID = "SETDETAILSPPID";
export const RESETDETAILSPPID = "RESETDETAILPPID";
export const SETMENULISTPPID = "SETMENULISTPPID";
export const RESETMENULISTPPID = "RESETMENULISTPPID";
export const SETDETAILBYID = "SETDETAILBYID";
export const RESETDETAILBYID = "RESETDETAILBYID";
export const SETFILEBYID = "SETFILEBYID";
export const RESETFILEBYID = "RESETFILEBYID";
